import TocIcon from "@mui/icons-material/Toc";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  PRIORITIES_URL,
  RESPONSE_RESOLVE_BY_SLA_URL,
  RESPONSE_RESOLVE_URL,
} from "../../../Constants/Constants";
import {
  DAY,
  HOUR,
  MINUTE,
  MONTH,
  SEQ_ONE,
  SEQ_THREE,
  SEQ_TWO,
} from "../../../Constants/StatusConstants";
import { USER_ORG_ID } from "../../../Constants/StorageConstants";
import AxiosInstance from "../../../services/AxiosInstance";
import { useAlert } from "../../alerts/AlertContext";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";

function RespAndResolutionDialog({ slaId }) {
  const [open, setOpen] = React.useState(false);
  const [priorityp1, setPriorityp1] = useState("");
  const [priorityp2, setPriorityp2] = useState("");
  const [priorityp3, setPriorityp3] = useState("");
  const [priorities, setPriorities] = useState([]);

  const [responseOne, setResponseOne] = useState("");
  const [responseTwo, setResponseTwo] = useState("");
  const [responseThree, setResponseThree] = useState("");

  const [responseTimeOne, setResponseTimeOne] = useState("");
  const [responseTimeTwo, setResponseTimeTwo] = useState("");
  const [responseTimeThree, setResponseTimeThree] = useState("");

  const [resolveOne, setResolveOne] = useState("");
  const [resolveTwo, setResolveTwo] = useState("");
  const [resolveThree, setResolveThree] = useState("");

  const [resolveTimeOne, setResolveTimeOne] = useState("");
  const [resolveTimeTwo, setResolveTimeTwo] = useState("");
  const [resolveTimeThree, setResolveTimeThree] = useState("");

  const [escalationOne, setEscalationOne] = React.useState(false);
  const [escalationTwo, setEscalationTwo] = React.useState(false);
  const [escalationThree, setEscalationThree] = React.useState(false);

  const [responseResolves, setResponseResolves] = useState([]);

  const [responseResolve, setResponseResolve] = useState({
    priority: {},
    sla: {},
    organization: {},
    response: "",
    responseTime: "",
    resolve: "",
    resolveTime: "",
    escalation: false,
  });

  const showAlert = useAlert();

  useEffect(() => {
    getPriorities();
    //getResponseAndReolution();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResponseOneChange = (event) => {
    setResponseOne(event.target.value);
  };
  const handleResponseTwoChange = (event) => {
    setResponseTwo(event.target.value);
  };
  const handleResponseThreeChange = (event) => {
    setResponseThree(event.target.value);
  };

  const handleResponseTimeOneChange = (event) => {
    setResponseTimeOne(event.target.value);
  };
  const handleResponseTimeTwoChange = (event) => {
    setResponseTimeTwo(event.target.value);
  };
  const handleResponseTimeThreeChange = (event) => {
    setResponseTimeThree(event.target.value);
  };

  const handleResolveOneChange = (event) => {
    setResolveOne(event.target.value);
  };
  const handleResolveTwoChange = (event) => {
    setResolveTwo(event.target.value);
  };
  const handleResolveThreeChange = (event) => {
    setResolveThree(event.target.value);
  };

  const handleResolveTimeOneChange = (event) => {
    setResolveTimeOne(event.target.value);
  };
  const handleResolveTimeTwoChange = (event) => {
    setResolveTimeTwo(event.target.value);
  };
  const handleResolveTimeThreeChange = (event) => {
    setResolveTimeThree(event.target.value);
  };

  const handleEscalationOneChange = (event) => {
    setEscalationOne(event.target.value);
  };
  const handleEscalationTwoChange = (event) => {
    setEscalationTwo(event.target.value);
  };
  const handleEscalationThreeChange = (event) => {
    setEscalationThree(event.target.value);
  };

  const getPriorities = async () => {
    await AxiosInstance.get(PRIORITIES_URL).then((response) => {
      setPriorities(response.data.data);

      response.data.data.map((pr) => {
        if (pr.seq === SEQ_ONE) setPriorityp1(pr.id);
        if (pr.seq === SEQ_TWO) setPriorityp2(pr.id);
        if (pr.seq === SEQ_THREE) setPriorityp3(pr.id);
      });

      getResponseAndResolution(response.data.data);
    });
  };

  const getResponseAndResolution = async (prioritiesData) => {
    await AxiosInstance.get(RESPONSE_RESOLVE_BY_SLA_URL + slaId).then(
      (response) => {
        setResponseResolves(response.data);

        if (response.data.length > 0) {
          response.data.map((rr) => {
            if (rr.priority.seq === SEQ_ONE) {
              setResponseOne(rr.response);
              setResponseTimeOne(rr.responseTime);
              setResolveOne(rr.resolve);
              setResolveTimeOne(rr.resolveTime);
              setEscalationOne(rr.escalation);
            }
            if (rr.priority.seq === SEQ_TWO) {
              setResponseTwo(rr.response);
              setResponseTimeTwo(rr.responseTime);
              setResolveTwo(rr.resolve);
              setResolveTimeTwo(rr.resolveTime);
              setEscalationTwo(rr.escalation);
            }

            if (rr.priority.seq === SEQ_THREE) {
              setResponseThree(rr.response);
              setResponseTimeThree(rr.responseTime);
              setResolveThree(rr.resolve);
              setResolveTimeThree(rr.resolveTime);
              setEscalationThree(rr.escalation);
            }
          });
        }
      }
    );
  };

  const saveResponseAndReolution = () => {
    if (responseResolves.length > 0) {
      responseResolves.map((rr) => {
        if (rr.priority.seq === SEQ_ONE) {
          responseResolve.id = rr.id;
          responseResolve.priority = { id: rr.priority.id };
          responseResolve.response = responseOne;
          responseResolve.responseTime = responseTimeOne;
          responseResolve.resolve = resolveOne;
          responseResolve.resolveTime = resolveTimeOne;
          responseResolve.escalation = escalationOne === "on" ? true : false;
        }
        if (rr.priority.seq === SEQ_TWO) {
          responseResolve.id = rr.id;
          responseResolve.priority = { id: rr.priority.id };
          responseResolve.response = responseTwo;
          responseResolve.responseTime = responseTimeTwo;
          responseResolve.resolve = resolveTwo;
          responseResolve.resolveTime = resolveTimeTwo;
          responseResolve.escalation = escalationTwo === "on" ? true : false;
        }

        if (rr.priority.seq === SEQ_THREE) {
          responseResolve.id = rr.id;
          responseResolve.priority = { id: rr.priority.id };
          responseResolve.response = responseThree;
          responseResolve.responseTime = responseTimeThree;
          responseResolve.resolve = resolveThree;
          responseResolve.resolveTime = resolveTimeThree;
          responseResolve.escalation = escalationThree === "on" ? true : false;
        }
        responseResolve.sla = { id: slaId };
        responseResolve.organization = {
          id: localStorage.getItem(USER_ORG_ID),
        };

        AxiosInstance.post(RESPONSE_RESOLVE_URL, responseResolve)
          .then((response) => {
            showAlert(
              "Response and Resolution created successfully!",
              "success"
            );
          })
          .catch((error) => {
            showAlert("Response and Resolution creation failed!", "error");
            console.error(error);
          });
      });
    } else {
      priorities.map((pr) => {
        if (pr.seq === SEQ_ONE) {
          responseResolve.priority = { id: pr.id };
          responseResolve.response = responseOne;
          responseResolve.responseTime = responseTimeOne;
          responseResolve.resolve = resolveOne;
          responseResolve.resolveTime = resolveTimeOne;
          responseResolve.escalation = escalationOne === "on" ? true : false;
        }
        if (pr.seq === SEQ_TWO) {
          responseResolve.priority = { id: pr.id };
          responseResolve.response = responseTwo;
          responseResolve.responseTime = responseTimeTwo;
          responseResolve.resolve = resolveTwo;
          responseResolve.resolveTime = resolveTimeTwo;
          responseResolve.escalation = escalationTwo === "on" ? true : false;
        }

        if (pr.seq === SEQ_THREE) {
          responseResolve.priority = { id: pr.id };
          responseResolve.response = responseThree;
          responseResolve.responseTime = responseTimeThree;
          responseResolve.resolve = resolveThree;
          responseResolve.resolveTime = resolveTimeThree;
          responseResolve.escalation = escalationThree === "on" ? true : false;
        }
        responseResolve.sla = { id: slaId };
        responseResolve.organization = {
          id: localStorage.getItem(USER_ORG_ID),
        };

        AxiosInstance.post(RESPONSE_RESOLVE_URL, responseResolve)
          .then((response) => {
            showAlert(
              "Response and Resolution created successfully!",
              "success"
            );
          })
          .catch((error) => {
            showAlert("Response and Resolution creation failed!", "error");
            console.error(error);
          });
      });
    }
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        <Link onClick={handleClickOpen}>{<TocIcon />}</Link>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              saveResponseAndReolution();
              handleClose();
            },
          }}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1000px", // Set your width here
              },
            },
          }}
        >
          <DialogTitle>Response And Resolution</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1, width: "25ch" } }}
              noValidate
              autoComplete="off"
            >
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Priority</TableCell>
                    <TableCell align="right">Respond within</TableCell>
                    <TableCell align="right">&nbsp;</TableCell>
                    <TableCell align="right">Resolve within</TableCell>
                    <TableCell align="right">&nbsp;</TableCell>
                    <TableCell align="right">Escalation Mail</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Priority
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={priorityp1}
                          disabled
                          //onChange={handlePriorityChange}
                          label="Priority"
                        >
                          <MenuItem value="">
                            {" "}
                            <em>None </em>{" "}
                          </MenuItem>
                          {priorities.map((pr) => (
                            <MenuItem value={pr.id}>{pr.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="rs1"
                        size="small"
                        style={{ width: 70 }}
                        value={responseOne}
                        onChange={handleResponseOneChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={responseTimeOne}
                          onChange={handleResponseTimeOneChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="res1"
                        size="small"
                        value={resolveOne}
                        style={{ width: 70 }}
                        onChange={handleResolveOneChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={resolveTimeOne}
                          onChange={handleResolveTimeOneChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <Switch
                        checked={escalationOne}
                        onChange={handleEscalationOneChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Priority
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={priorityp2}
                          // onChange={handlePriorityChange}
                          disabled
                          label="Priority"
                        >
                          <MenuItem value="">
                            {" "}
                            <em>None </em>{" "}
                          </MenuItem>
                          {priorities.map((pr) => (
                            <MenuItem value={pr.id}>{pr.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="rs2"
                        size="small"
                        value={responseTwo}
                        style={{ width: 70 }}
                        onChange={handleResponseTwoChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={responseTimeTwo}
                          onChange={handleResponseTimeTwoChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="res2"
                        size="small"
                        value={resolveTwo}
                        style={{ width: 70 }}
                        onChange={handleResolveTwoChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={resolveTimeTwo}
                          onChange={handleResolveTimeTwoChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <Switch
                        checked={escalationTwo}
                        onChange={handleEscalationTwoChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Priority
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={priorityp3}
                          disabled
                          //onChange={handlePriorityChange}
                          label="Priority"
                        >
                          <MenuItem value="">
                            {" "}
                            <em>None </em>{" "}
                          </MenuItem>
                          {priorities.map((pr) => (
                            <MenuItem value={pr.id}>{pr.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="rs3"
                        size="small"
                        value={responseThree}
                        style={{ width: 70 }}
                        onChange={handleResponseThreeChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={responseTimeThree}
                          onChange={handleResponseTimeThreeChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <TextField
                        autoFocus
                        id="outlined-multiline-static"
                        name="res3"
                        size="small"
                        value={resolveThree}
                        style={{ width: 70 }}
                        onChange={handleResolveThreeChange}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <FormControl
                        variant="outlined"
                        sx={{ m: 1, minWidth: 70 }}
                      >
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={resolveTimeThree}
                          onChange={handleResolveTimeThreeChange}
                        >
                          <MenuItem value={MONTH}>
                            {" "}
                            <em>Mos</em>{" "}
                          </MenuItem>
                          <MenuItem value={DAY}>
                            {" "}
                            <em>Days</em>{" "}
                          </MenuItem>
                          <MenuItem value={HOUR}>
                            {" "}
                            <em>Hr</em>{" "}
                          </MenuItem>
                          <MenuItem value={MINUTE}>
                            {" "}
                            <em>Min</em>{" "}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="right">
                      <Switch
                        checked={escalationThree}
                        onChange={handleEscalationThreeChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default RespAndResolutionDialog;
